import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';
import { num_word } from 'vpl.tas';


export const MpCatalogSections = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {
        num_word: num_word,
        showMore(event) {
            let btn = $(event.target),
                list = $(this.$el).find('.js-equipment-list');
            if (!btn.hasClass('is-show')) {
                btn.addClass('is-show');
                btn.text('Свернуть');
                list.addClass('is-show');
            } else {
                btn.removeClass('is-show');
                btn.text('Показать ещё');
                list.removeClass('is-show');
                $('html').animate({
                    scrollTop: list.offset().top - 150
                }, 500);
            }
        }
    },
    updated() {

    },
    mounted() {

    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    template: `
<section v-if="this.struct[this.structKey].componentData.ITEMS" class="section">
    <div class="container">
        <div class="section__heading-wp">
            <div class="section__heading">
                <div class="section__title-wp">
                    <h2 class="section__title">
                        Профессиональное оборудование
                        для магазинов,  ресторанов, отелей
                    </h2>
                </div>
            </div>
        </div>
        <div class="equipment__list js-equipment-list">

            <a v-for="item in this.struct[this.structKey].componentData.ITEMS" :key="item.ID" :href="item.LINK" class="equipment__item js-equipment-item">
                <div class="equipment__item-title">{{item.NAME}}</div>
                <div class="equipment__item-amount">{{item.COUNT}} {{this.num_word(item.COUNT, ['модель', 'модели', 'моделей'])}}</div>
                <div class="equipment__item-img" :class="{'no-photo': item.PICTURE == false}">
                    <img v-if="item.PICTURE !== false" class="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.PICTURE" :alt="item.NAME" :title="item.NAME">
                    <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="item.NAME" :title="item.NAME">
                </div>
            </a>

        </div>
        <a href="#" class="btn btn--border btn-show js-equipment-show" @click.prevent="showMore($event)">
            Показать ещё
        </a>
    </div>
</section>
    `
}